import { useState } from "react";
import Logo from "@/components/base/Logo";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { label: "Accueil", href: "/" },
    { label: "Réparation", href: "/reparation-volet-roulant" },
    { label: "Dépannage", href: "/depannage-urgence" },
    { label: "Pose", href: "/pose-volet-roulant" },
    { label: "Moteur Somfy", href: "/moteur-somfy" },
    { label: "Moteur Nice", href: "/moteur-nice" },
    { label: "Contact", href: "#devis" },
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#E2E8F0] transition-all duration-300"
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center">
            <div className="hidden md:block">
              <Logo />
            </div>
            <div className="md:hidden">
              <Logo variant="compact" />
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-[#2F4A63] text-[15px] font-medium hover:text-[#E8734A] transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="tel:0374473240"
              className="hidden md:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-colors bg-[#1B2A4A] text-white hover:bg-[#1B2A4A]/90"
            >
              <i className="ri-phone-line text-base"></i>
              03 74 47 32 40
            </a>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-[#1B2A4A]"
              aria-label="Menu"
            >
              {isOpen ? <i className="ri-close-line text-2xl"></i> : <i className="ri-menu-line text-2xl"></i>}
            </button>

            <a
              href="tel:0374473240"
              className="md:hidden flex items-center gap-1 bg-[#E8734A] text-white px-2 py-1.5 rounded-full text-xs font-semibold min-w-0"
            >
              <i className="ri-phone-line text-sm"></i>
              03 74 47 32 40
            </a>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t border-[#E2E8F0]">
          <nav className="flex flex-col px-4 py-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-[#2F4A63] text-base font-medium py-3 px-2 hover:text-[#E8734A] transition-colors border-b border-[#E2E8F0] last:border-0"
                onClick={() => setIsOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}